import { createAsyncThunk } from '@reduxjs/toolkit';
import { StoreState } from '../../../../store/store.interface';
import { savePurchaseOrderMagentoApiCall } from '../api/shop-cart.api';
import { ActionStatus } from '../../../../common/constants/action-status';
import { PurchaseOrderDetails } from '../../../checkout/shop-checkout.interface';

export const savePurchaseOrder = createAsyncThunk(
  'shopCart/savePurchaseOrder',
  async (requestPayload: PurchaseOrderDetails, thunkAPI) => {
    try {
      return await savePurchaseOrderMagentoApiCall(requestPayload);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
  {
    condition: (_arg, { getState }) => {
      const state = getState() as StoreState;
      if (
        state.shopCheckoutState.savePurchaseOrder.status == ActionStatus.loading ||
        state.shopCheckoutState.savePurchaseOrder.status == ActionStatus.succeeded
      ) {
        return false;
      }
      return true;
    },
  }
);
